import { render } from "./totalmeasurementlist.vue?vue&type=template&id=11292081"
import script from "./totalmeasurementlist.vue?vue&type=script&lang=js"
export * from "./totalmeasurementlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__